import { type FormEvent, useState } from 'react';
import { ApiError, api } from '../lib/api';
import { useAutoFocus } from '../lib/useAutoFocus';
import { OwlLogo } from './shared';

export function Login({ onSuccess }: { onSuccess: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const autoFocusRef = useAutoFocus<HTMLInputElement>();

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.login(email, password);
      onSuccess();
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : 'Login failed';
      setError(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-shell">
      <form onSubmit={submit} className="login-card">
        <div className="login-brand">
          <OwlLogo size={42} />
          <div className="login-wordmark">OWL</div>
          <div className="login-tag">Observe · Warn · Log</div>
        </div>
        <label className="login-label" htmlFor="email">
          Email
        </label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          className="login-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          ref={autoFocusRef}
        />
        <label className="login-label" htmlFor="password">
          Password
        </label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          className="login-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <div className="login-error">{error}</div>}
        <button type="submit" className="login-submit" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
